import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { getUserPosts, createPost } from "../services/postService";
import PostForm from "../components/Post/PostForm";
import PostCard from "./PostCard";
import "./Dashboard.css";


const Dashboard = () => {
    const { isAuthenticated, loading: authLoading } = useAuth();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!isAuthenticated) return;
        const fetchPosts = async () => {
            try {
                const data = await getUserPosts();
                setPosts(data);
            } catch (err) {
                console.error("Failed to load posts", err);
                setError("無法加載貼文，請稍後再試。");
            } finally {
                setLoading(false);
            }
        };
        fetchPosts();
    }, [isAuthenticated]);

    const handleNewPost = async (formData) => {
        try {
            const newPost = await createPost(formData);
            setPosts((prevPosts) => [newPost, ...prevPosts]);
            return newPost;
        } catch (error) {
            console.error("Failed to create post", error);

            if (error.response && error.response.data) {
                const errorMessages = Object.entries(error.response.data)
                    .map(([field, messages]) => {
                        const messageText = Array.isArray(messages) ? messages.join(", ") : messages;
                        return `${field}: ${messageText}`;
                    })
                    .join("\n");
                throw new Error(errorMessages);
            }

            if (error.request) {
                throw new Error("無法連線到伺服器，請檢查網路。");
            }

            throw new Error(error.message || "尚未登入或登入已過期，請重新登入。");
        }
    };

    if (authLoading) {
        return (
            <div className="main-content dashboard-page">
                <div className="dashboard-status-card">正在驗證身份...</div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return (
            <div className="main-content dashboard-page">
                <section className="dashboard-hero">
                    <div className="dashboard-hero-content">
                        <div className="dashboard-hero-header">
                            <h1 className="dashboard-hero-title">創作夜晚故事</h1>
                            <p className="dashboard-hero-subtitle">登入後即可與社群分享您在東南亞的夜間冒險。</p>
                        </div>
                        <div className="dashboard-form-preview">
                            <div className="dashboard-form-template">
                                <PostForm onPostSubmit={handleNewPost} bareLayout />
                            </div>
                            <div className="dashboard-locked-message">
                                <h2>請先登入</h2>
                                <p>登入後即可啟用完整的發文與管理功能。</p>
                                <div className="dashboard-locked-actions">
                                    <button onClick={() => (window.location.href = "/login")}>前往登入</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div className="main-content dashboard-page">
            <section className="dashboard-hero">
                <div className="dashboard-hero-content">
                    <div className="dashboard-hero-header">
                        <h1 className="dashboard-hero-title">創作夜晚故事</h1>
                        <p className="dashboard-hero-subtitle">分享您最難忘的夜間回憶，讓旅人社群一同感受熱帶城市的脈動。</p>
                    </div>
                    <div className="dashboard-form-preview">
                        <PostForm onPostSubmit={handleNewPost} bareLayout />
                    </div>
                </div>
            </section>

            <section className="dashboard-section">
                <div className="dashboard-section-header">
                    <h2 className="dashboard-section-title">我的貼文紀錄</h2>
                </div>
                <div className="dashboard-section-body">
                    {loading ? (
                        <div className="dashboard-feed-status">🔄 正在載入貼文...</div>
                    ) : error ? (
                        <div className="dashboard-feed-status" role="alert">{error}</div>
                    ) : posts.length > 0 ? (
                        <div className="dashboard-feed-grid">
                            {posts.map((post) => (
                                <PostCard key={post.id} post={post} />
                            ))}
                        </div>
                    ) : (
                        <div className="dashboard-empty-state">
                            <span className="dashboard-empty-icon">🌙</span>
                            <p>還沒有故事紀錄，成為第一個分享夜晚冒險的人吧！</p>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default Dashboard;
